<template>
<div>
  <div v-show="step === 0" class="card-page-container">
    <div class="mdl-grid fill">
      <div class="mdl-card mdl-cell fill mdl-shadow--2dp">
        <div class="mdl-card__title">
          <h2 class="mdl-card__title-text">{{'reset.label.title' | label}}</h2>
        </div>
        <div class="mdl-card__supporting-text fill">
          <validator name="resetValidator">
            <form novalidate>
              <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill">
                <input type="password" class="mdl-textfield__input" id="newPassword"
                       v-model="newPassword" initial="off" v-validate:newPassword="['password']">
                <label class="mdl-textfield__label" for="newPassword">{{'reset.label.newPassword' | label}}</label>
                <span class="validation-error mdl-textfield__error" v-if="$resetValidator.newpassword.password">{{'reset.validation.newPassword' | label}}</span>
              </div>
            </form>
          </validator>
        </div>
        <div class="mdl-card__actions">
          <div class="card-grid mdl-grid">
            <div class="mdl-cell mdl-cell--8-col">
            </div>
            <div class="mdl-cell mdl-cell--4-col">
              <div class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored fill"
                   v-on:click="resetPassword()">
                {{'reset.button.save' | label}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-show="step === 1" class="card-page-container"  >
    <div class="mdl-grid">
      <div class="mdl-layout-spacer"></div>
      <div class="mdl-cell fill mdl-shadow--2dp">
        <alert :message=alertMessage :goto="next"></alert>
      </div>
      <div class="mdl-layout-spacer"></div>
    </div>
  </div>
</div>
</template>

<script>
  var api = require('api')
  module.exports = {
    ready: function () {
      var token = this.$route.params.token
      api.UrlAction.get({token: token}).then(function (response) {
      }, this.onError)
    },
    components: {
      alert: require('c/components/Alert')
    },
    data: function () {
      return {
        newPassword: '',
        step: 0,
        alertMessage: '',
        next: '/app/login'
      }
    },
    methods: {
      onError: function (err) {
        var self = this
        if (err.status >= 400 && err.status < 500) {
          self.alertMessage = err.data.message
          self.step = 1
        } else {
          self.$dispatch('show-error', err.data)
        }
      },
      resetPassword: function () {
        var self = this
        this.$validate(true, function () {
          if (self.$resetValidator.invalid) {
            return
          }
          var token = self.$route.params.token
          api.User.resetPassword({newPassword: self.newPassword, token: token}).then(function (response) {
            self.alertMessage = response.data
            self.step = 1
          }, function (err) {
            self.onError(err)
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ResetPassword.vue?b077ec9a